/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Checkbox, Collapse, Popover } from 'antd'
import uuid from 'uuid'
import { isMobile } from 'react-device-detect'
import { PopoverIco } from '@shared/Icon/EtcIcon'
import { BETTING_HISTORY_TAB_KEY, SIDE_MENU } from '@constants/index'
import Slide from 'react-reveal/Slide'
import * as _ from 'lodash'
// icon
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
import { CircleDownIco } from '@shared/Icon/ArrowIcon'
import { BetIco, LiveTagIco, MixTagIco } from '@shared/Icon/MatchupIcon'
import SuccessImg from '@assets/images/icon/betting_history_icon/success.png'
import FailImg from '@assets/images/icon/betting_history_icon/fail.png'
import CancelImg from '@assets/images/icon/betting_history_icon/cancel.png'
import CancelBettorImg from '@assets/images/icon/betting_history_icon/cancel-bettor.png'
import QuestionImg from '@assets/images/icon/etc_icon/question-ico.png'
import BettingCancelImg from '@assets/images/icon/betting_history_icon/betting-cancel.png'
import ClubMessageImg from '@assets/images/icon/betting_history_icon/club-message.png'
import PickImg from '@assets/images/icon/betting_history_icon/pick.png'
import WritePickImg from '@assets/images/icon/betting_history_icon/write-pick.png'
import KeepIco from '@assets/images/icon/betting_history_icon/keep.png'
import DeleteIco from '@assets/images/icon/betting_history_icon/delete.png'
import AdditionalDividendMarkImg from '@assets/images/icon/matchup_icon/dividend-card/additional-dividend-mark.png'
// css
import { BetCouponTag } from '@styles/base.style'
import { BettingHistoryShareBtnStyle, Button } from '@styles/button.style'
import * as Utils from '@utils/utils'
import {
  bettingRecordTrackToSchema$ComponentBettingParamMatch,
  formatNumber,
  getBettingTime,
  getRatioTicketMoney,
} from '@utils/utils'
import { BET_CANCEL_TYPE, BET_HIT_STATE, BET_TYPE_ON, EXTRA_ODDS_TYPE, PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import { BettingRecordTrack } from '@store/bettingHistoryStore'
import useRootStore from '@store/useRootStore'
import { ComponentBettingParams } from '@store/componentStore'
import { getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated } from '@utils/jsxutils'
import { BettingHistoryListItemTournament } from './BettingHistoryListItemTournament'
import BettingHistoryListItemSpecial from './BettingHistoryListItemSpecial'
import { BettingHistoryHeader, BettingHistoryQuickMenu } from './index.style'
import { PAGE_TYPE } from '@interface/common'
import PopupUtils from '@utils/popup-utils'
import { FROM_VIEW_TYPE, USER_PENALTY_TYPE } from '@v2/constants/common'
import DialogUtils from '@utils/dialog-utils'
import StorageUtils from '@utils/storage-utils'

interface BettingHistoryListProps {
  track: BettingRecordTrack
  idx: string
  onNeedFetch?: any
  currentTabKey: BETTING_HISTORY_TAB_KEY
  onClickBettingStorage: (bettorBetId: string) => void
  fetchItems?: (resetForce: boolean, clubId: string) => Promise<void>
  pageType?: PAGE_TYPE
  fromViewType?: FROM_VIEW_TYPE
}

const BettingHistoryListItem: React.FC<BettingHistoryListProps> = (props: BettingHistoryListProps) => {
  const { track, idx, onNeedFetch, currentTabKey, onClickBettingStorage, fetchItems, pageType, fromViewType } = props
  const { betId, close1, close2, bet, firstDateOfMatch, folds, userPickWritten, userPickWrittenAll } = track
  const {
    clubId,
    createdAt,
    clubName,
    typeOn,
    foldCount,
    betMoney,
    dividend,
    dividendRate,
    pickId,
    betMoneyType,
    canceled,
    cancelType,
    category,
    extraOddsType,
    extraOddsItemPropertyId,
  } = bet
  const { bettingHistoryStore, globalStore, componentStore, matchupStore, penaltyStore, clubStore } = useRootStore()
  const { showBettingListItemSelectBtn } = globalStore
  const { deleteBetActive, onGoingBetCount } = bettingHistoryStore
  const { simpleClubs } = clubStore
  const finalBetMoney = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? getRatioTicketMoney(betMoney) : betMoney
  const finalDividend = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? getRatioTicketMoney(dividend) : dividend
  const [visiblePopover, setVisiblePopover] = useState(false)
  const [deleteChecked, setDeleteChecked] = useState(false)
  // 베팅권 팝업
  // const [visibleBetCoupon, setVisibleBetCoupon] = useState(false)
  const { Panel } = Collapse

  const hitState = canceled === false ? bet.hitState : BET_HIT_STATE.CANCEL

  const makeElementHitStateCircle = (foldHitState: number[]) => {
    const circleClassNames = []
    const elCircles = []
    for (const state of foldHitState) {
      switch (state) {
        case BET_HIT_STATE.SUCCESS:
          circleClassNames.push('success')
          break
        case BET_HIT_STATE.CANCEL:
          circleClassNames.push('cancel')
          break
        case BET_HIT_STATE.ONGOING:
          circleClassNames.push('ongoing')
          break
      }
    }

    let keyIndex = 0
    for (const className of circleClassNames) {
      keyIndex += 1
      const key = `match-state-circle-${className}-${keyIndex}`
      elCircles.push(<span key={key} className={`match-state--circle ${className}`}/>)
    }

    return (<div className="match-state">{elCircles}</div>)
  }

  const elOnGoingHitStateCircle = () => {
    const foldHitState: number[] = []
    for (const key in folds) {
      const fold = folds[key]
      for (const data of fold.data) {
        foldHitState.push(data.hitState)
      }
    }

    return makeElementHitStateCircle(foldHitState)
  }

  let eleHitState
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      eleHitState = <img src={SuccessImg} alt="적중" className="hit-state-img"/>
      break
    case BET_HIT_STATE.FAIL:
      eleHitState = <img src={FailImg} alt="미적중" className="hit-state-img"/>
      break
    case BET_HIT_STATE.CANCEL:
      if (currentTabKey === BETTING_HISTORY_TAB_KEY.SHARED && cancelType !== BET_CANCEL_TYPE.NONE) {
        eleHitState = <img src={CancelBettorImg} alt="베팅 취소" className="hit-state-img"/>
      } else {
        eleHitState = <img src={CancelImg} alt="적중 특례" className="hit-state-img"/>
      }
      break
    case BET_HIT_STATE.ONGOING:
      eleHitState = elOnGoingHitStateCircle()
      break
  }

  const onClickShowPickSaleDrawer = () => {
    bettingHistoryStore.setPublishPickBetting(betId)
  }

  const onClickPickSellButton = event => {
    event.stopPropagation()
    onClickShowPickSaleDrawer()
  }

  const makeCancelDialogText = (): string[] => {
    let text = ['베팅을 취소하시겠습니까?']
    if (extraOddsType === EXTRA_ODDS_TYPE.GOD_BLESS_ITEM) {
      const def = componentStore.getExtraOddsItemDetailByPropertyId(extraOddsItemPropertyId)
      if (!_.isEmpty(def)) {
        const count = componentStore.getUserExtraOddsItemCountByPropertyId(extraOddsItemPropertyId)
        if (count >= def.maxCount) {
          text = [
            '신의 가호는 최대 9999개까지 보유할 수 있습니다.'
            , '베팅 취소 시 신의 가호가 반환되지 않습니다.'
            , '베팅을 취소하시겠습니까?',
          ]
        }
      }
    }
    return text
  }

  const onClickCancellingBet = event => {
    event.stopPropagation()
    if (userPickWritten) {
      Utils.showToast(Utils.TOAST_TYPE.INFO, '분석글 경기는 취소할 수 없습니다.')
    } else {
      globalStore.pushDialogYesNo({
        title: '알림',
        text: makeCancelDialogText(),
        className: 'small-size',
        positivePress: '확인',
        negativePress: '취소',
        callbackPositive: async () => {
          const result = await bettingHistoryStore.cancelBet(betId)

          if (result && onNeedFetch) {
            onNeedFetch()
          }
        },
      })
    }
  }

  const onClickOpenEditor = () => {
    if (bettingHistoryStore.selectedBettingHistoryFoldData) {
      PopupUtils.showUserPickEditor(FROM_VIEW_TYPE.BETTING_HISTORY)
    }
  }

  const showBettingHistory = (fromViewType: FROM_VIEW_TYPE = FROM_VIEW_TYPE.USER_PICK) => {
    StorageUtils.saveShowUserPickFirstInfo()
    bettingHistoryStore.resetSelectedBettingHistory(fromViewType)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: true, fromViewType })
    PopupUtils.showBettingHistory({ onClick: onClickOpenEditor, pageType: PAGE_TYPE.USER_PICK })
  }

  const onClickUserPickWriter = async () => {
    const penaltyCheckResult = await penaltyStore.checkUserPenalty(USER_PENALTY_TYPE.USER_PICK)
    if (_.isEmpty(penaltyCheckResult)) {
      const item = StorageUtils.isShowUserPickFirstInfo()
      if (item) {
        showBettingHistory(FROM_VIEW_TYPE.USER_PICK)
      } else {
        if (onGoingBetCount === 0) {
          StorageUtils.saveShowUserPickFirstInfo()
          DialogUtils.showUserPickNullOngoingBetInfo()
        } else {
          DialogUtils.showUserPickIsOngoingBetInfo({ closeCallback: showBettingHistory })
        }
      }
    } else {
      DialogUtils.showPenaltyInfo(penaltyCheckResult)
    }
  }

  useEffect(() => {
    if (!deleteBetActive && deleteChecked) {
      setDeleteChecked(false)
    }
  }, [deleteBetActive])

  const onClickShowClubMessage = event => {
    event.stopPropagation()

    componentStore.setExtraClubId(clubId)
    globalStore.setVisibleMessageBox(true, true)
  }

  const onClickDeleteBet = (event) => {
    event.preventDefault()
    setVisiblePopover(false)
    setDeleteChecked(true)
    bettingHistoryStore.setDeleteBetActive(true)
    bettingHistoryStore.addDeleteBetterBetIds(betId)
    globalStore.setIgnoreVisibleChangeHandler(false)
  }

  const onClickAddStorageBet = (event) => {
    event.preventDefault()
    setVisiblePopover(false)
    fetchStorageBet(true)
  }

  const onClickRemoveStorageBet = (event) => {
    event.preventDefault()
    setVisiblePopover(false)
    fetchStorageBet(false)
  }

  const onChangeDeleteCheckBox = (e) => {
    const checked = e.target.checked
    setDeleteChecked(checked)
    if (checked) {
      bettingHistoryStore.addDeleteBetterBetIds(betId)
    } else {
      bettingHistoryStore.removeDeleteBetterBetIds(betId)
    }
  }

  const onVisibleChange = (visible) => {
    setVisiblePopover(visible)
  }

  const fetchStorageBet = async (isStorage: boolean) => {
    await bettingHistoryStore.fetchStorageBettingHistory(isStorage, betId)
    if (onClickBettingStorage) {
      onClickBettingStorage(betId)
    }
  }

  const onClickBettingButton = async e => {
    e.stopPropagation()

    const result = await componentStore.validateClub(clubId)
    if (result) {
      const { club } = await componentStore.api.club.getClubInfo({ clubId })
      const matches = bettingRecordTrackToSchema$ComponentBettingParamMatch(track)
      const componentBettingParams: ComponentBettingParams = {
        bettorBetId: betId,
        club,
        typeOn: bet.typeOn,
        callType: bet.callType,
        matches,
        betMoney: 0,
        betMoneyType: PROPERTY_ID.MONEY,
        pickId: null,
        matchupCategory: category,
      }
      const values = Object.values(folds)

      componentStore.setComponentBettingParams(componentBettingParams, true)
      componentStore.setCartItemsFromBettingFoldGrouped(values)
    }
  }

  // const popoverContent = <p className="popover-content-txt">{typeOn === BET_TYPE_ON.UNIFIED_LIVE ? '라이브 베팅은 취소할 수 없습니다.' : '베팅후 10분까지만 취소가 가능합니다.'}</p>
  let popoverContent

  if (typeOn === BET_TYPE_ON.UNIFIED_LIVE) {
    popoverContent = <p className="popover-content-txt">라이브 베팅은 취소할 수 없습니다.</p>
  } else if (typeOn === BET_TYPE_ON.MIX) {
    popoverContent = <p className="popover-content-txt">믹스 베팅은 취소할 수 없습니다.</p>
  } else if (userPickWritten) {
    popoverContent = <p className="popover-content-txt">
      분석글이 등록된 베팅은 취소가 불가합니다.
    </p>
  } else {
    popoverContent = <p className="popover-content-txt">
      베팅 후 10분까지만 취소가 가능합니다.
      <br/>
      (단, 경기시작 5분 전부터는 취소불가)
    </p>
  }

  let pickButton
  let bettingCancelButton
  let CancelToolTip
  let writeUserPickButton

  if (!userPickWrittenAll) {
    writeUserPickButton = (
      <Button
        className="history-quick-btn"
        onClick={() => {
          setVisiblePopover(false)
          onClickUserPickWriter()
        }}
      >
        <img src={WritePickImg} alt="" className="history-quick-btn--img"/>
        분석글 작성
      </Button>
    )
  }

  switch (hitState) {
    case BET_HIT_STATE.ONGOING: {
      const firstMatchTime = firstDateOfMatch.valueOf()
      let now = new Date()
      now = new Date(now.setMinutes(now.getMinutes() + 30))
      if (globalStore.isAvailableMenu(SIDE_MENU.PICK) && !pickId && firstMatchTime > now.valueOf()) {
        pickButton = (
          <Button className="history-quick-btn" onClick={onClickPickSellButton}>
            <img src={PickImg} alt="" className="history-quick-btn--img"/>
            픽 생성
          </Button>
        )
      }

      now = new Date()
      const nowBettingCancelTime = new Date(now.setMinutes(now.getMinutes() + 5))

      if (currentTabKey !== BETTING_HISTORY_TAB_KEY.SAVED) {
        if (!userPickWritten && firstMatchTime > nowBettingCancelTime.valueOf()) {
          bettingCancelButton = (
            <Button
              className="history-quick-btn"
              onClick={(event) => {
                setVisiblePopover(false)
                onClickCancellingBet(event)
              }}
            >
              <img src={BettingCancelImg} alt="" className="history-quick-btn--img"/>
              베팅 취소
            </Button>
          )
        } else {
          bettingCancelButton = (
            <Popover placement="topRight" content={popoverContent} trigger={isMobile ? 'click' : 'hover'}
                     overlayClassName={isMobile ? 'gray-popover mobile' : 'gray-popover'}>
              <Button className="history-quick-btn disabled" onClick={e => e.stopPropagation()}>
                <PopoverIco/>
                취소 불가
              </Button>
            </Popover>
          )
        }
      }
    }
      break
    case BET_HIT_STATE.CANCEL:
      if (canceled === true && cancelType === BET_CANCEL_TYPE.BY_CLUB) {
        const popoverTxt = <span className="popover-content-txt">클럽에서 취소한 베팅입니다.<br/>클럽 쪽지를 통해 문의해주세요.</span>
        const popoverTrigger = isMobile ? 'click' : 'hover'
        CancelToolTip = (
          <Popover
            placement="bottomLeft"    // topLeft 시 영역 바깥인지 표시되지 않는 상태로 임시 변경
            content={popoverTxt}
            trigger={popoverTrigger}
            overlayClassName={isMobile ? 'gray-popover mobile' : 'gray-popover'}
          >
            <p className="oz-cancel" id="ozCancel">
              클럽 취소
              <span className="oz-cancel--icon">
                  <span className="img-bg"/>
                  <img src={QuestionImg} alt="물음표 아이콘" className="img"/>
                </span>

            </p>
          </Popover>
        )
      }
      break
  }

  let AdditionalDividendMark

  const def = componentStore.getExtraOddsItemDetailByPropertyId(extraOddsItemPropertyId)
  if (!_.isEmpty(def)) {
    const popoverDividendTxt = <span className="popover-content-txt">신의가호 효과
      <span style={{ color: '#26aab8' }}>{`${def.name} +${def.rate} 배당`}</span></span>
    const popoverTrigger = isMobile ? 'click' : 'hover'
    AdditionalDividendMark = (
      <Popover
        placement="top"
        content={popoverDividendTxt}
        trigger={popoverTrigger}
        overlayClassName="white-popover only-txt"
        getPopupContainer={(triggerNode: any) => triggerNode.parentNode} /* body 하위에 div를 생성하지 않고 additional-dividend-mark과 동일 선상에 생성되도록 설정 - body 하위에 생성되면 아이폰에서 모달 뒤에 뜸 */
      >
        <span className="additional-dividend-mark">
          <img src={AdditionalDividendMarkImg} alt="신의가호 사용"/>
        </span>
      </Popover>
    )
  }

  // 베팅 삭제
  const deleteBetList = (
    <Button className="history-quick-btn" onClick={onClickDeleteBet}>
      <img src={DeleteIco} alt="" className="history-quick-btn--img"/>
      삭제
    </Button>
  )

  const keepBetList = (
    <Button className="history-quick-btn" onClick={onClickAddStorageBet}>
      <img src={KeepIco} alt="" className="history-quick-btn--img"/>
      보관
    </Button>
  )

  const removeKeepBetList = (
    <Button className="history-quick-btn" onClick={onClickRemoveStorageBet}>
      <img src={KeepIco} alt="" className="history-quick-btn--img"/>
      보관 해제
    </Button>
  )

  const dateOfBet = getBettingTime(createdAt)

  const sportIconElements = _.map(getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated(
    _.map(folds, fold => fold.sportId), matchupStore.feedSupplier), element => (
    <span key={uuid.v4()}>
      {element}
    </span>
  ))

  const elemHeader = (
    <div className="betting-history-header">
      <div className="my-bet-info">
        {eleHitState}
        <ul className="my-bet-info--list">
          <li className="my-bet-info--list--item money">
            {formatNumber(finalBetMoney)}
            {betMoneyType === PROPERTY_ID.DIA && (<DiaIco/>)}
            {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && (<GmoneyIco/>)}
          </li>
          <li className="my-bet-info--list--item rate">
            {Number(dividendRate).toFixed(2)}
          </li>
        </ul>
      </div>

      <div className="division-line header"/>

      <ul className="fold-money-list">
        <li className="fold-money-list--item fold">
          <span className="arrow-ico"><CircleDownIco/></span>
          {foldCount}

          <div className="sports-ico-wrap">
            {sportIconElements}
          </div>
        </li>
        <li className="fold-money-list--item final-dividend">
          {betMoneyType === PROPERTY_ID.DIA && '예상적중다이아'}
          {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && '예상적중머니'}
          <span className="final-dividend-value">{formatNumber(finalDividend)}</span>
          {betMoneyType === PROPERTY_ID.DIA && (<DiaIco/>)}
          {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && (<GmoneyIco/>)}
        </li>
      </ul>
    </div>
  )

  const eleCollapsed = []
  if (track.isSpecial === true) {
    for (const key in track.folds) {
      const fold = track.folds[key]
      eleCollapsed.push(
        <BettingHistoryListItemSpecial
          key={uuid.v4()}
          fold={fold}
          close1={close1}
          close2={close2}
        />,
      )
    }
  } else {
    for (const key in track.folds) {
      const fold = track.folds[key]
      eleCollapsed.push(
        <BettingHistoryListItemTournament
          key={uuid.v4()}
          track={track}
          fold={fold}
          betCanceled={track.bet.canceled}
          betCancelType={track.bet.cancelType}
          bettorBetId={track.betId}
          clubId={track.bet.clubId}
          isShareHistory={false}
          fetchItems={fetchItems}
          pageType={pageType}
          currentTabKey={currentTabKey}
          fromViewType={fromViewType}
        />,
      )
    }
  }

  const onClickBetHistoryItemSelectHandler = () => {
    bettingHistoryStore.setSelectedBettingHistoryByBettingRecordTrack(track, fromViewType)
  }

  const bettingHistoryQuickMenu = (
    <BettingHistoryQuickMenu>
      {currentTabKey === BETTING_HISTORY_TAB_KEY.ONGOING &&
        <ul className="quick-menu-list">
          <li className="quick-menu-list--item">{bettingCancelButton}</li>
          <li className="quick-menu-list--item">{writeUserPickButton}</li>
          <li className="quick-menu-list--item">{pickButton}</li>
        </ul>
      }

      {/* 마감 리스트일 경우 */}
      {currentTabKey === BETTING_HISTORY_TAB_KEY.CLOSED &&
        <ul className="quick-menu-list">
          <li className="quick-menu-list--item">{deleteBetList}</li>
          <li className="quick-menu-list--item">{keepBetList}</li>
          <li className="quick-menu-list--item">{writeUserPickButton}</li>
        </ul>
      }

      {/* 보관 리스트일 경우 */}
      {currentTabKey === BETTING_HISTORY_TAB_KEY.SAVED &&
        <ul className="quick-menu-list">
          <li className="quick-menu-list--item">{removeKeepBetList}</li>
        </ul>
      }

      <div className="betting-club">
        <span className="club-txt">클럽:</span>{clubName}
        <Button
          className="history-quick-btn"
          onClick={(event) => {
            setVisiblePopover(false)
            onClickShowClubMessage(event)
          }}
        >
          <img src={ClubMessageImg} alt="" className="history-quick-btn--img"/>
          쪽지보내기
        </Button>
      </div>
    </BettingHistoryQuickMenu>
  )

  const checkboxKey = `BettingHistoryListItem:Checkbox:${track.folds}`

  const { selectedBettingHistory } = bettingHistoryStore
  const targetTrack = selectedBettingHistory[fromViewType]

  const selectionChecked = targetTrack?.betId === track.betId
  const bettingHistoryQuickBtn = (
    <Button className="betting-history-quick-menu-btn">
      <span className="spots"/>
    </Button>
  )

  // const { body } = document
  // const { classList } = body
  // let popoverClass = 'betting-history-quick-menu mobile'
  //
  // if (classList.contains('body-scroll-hidden')) {
  //   popoverClass = 'betting-history-quick-menu bubble-modal'
  // }

  const fromUserPick = (): boolean => {
    return pageType === PAGE_TYPE.USER_PICK || pageType === PAGE_TYPE.USER_PICK_DETAIL
      || pageType === PAGE_TYPE.MATCHUP_DETAIL_PICK
  }
  const panelKey = `${betId}_${idx}_panel`

  let setPopoverPopup
  if (globalStore.visibleBubbleBetList) {
    setPopoverPopup = () => document.getElementById('betHistoryWrap')
  }

  const isMixBetting = typeOn === BET_TYPE_ON.MIX
  const club = _.find(simpleClubs, club => club.id === clubId) || {}
  const { grade, listImageUrl } = club
  const BettingHistoryList = (
    <BettingHistoryHeader>
      <div className="top-info">
        {dateOfBet}
        {/* 클럽 이미지 */}
        {Utils.isMembershipClub(grade) && listImageUrl && <div className="club-list-wrap">
          <img src={listImageUrl} onError={null} alt="클럽 아이콘" loading="lazy" className="icon"/>
        </div>
        }
        {/* 라이브 베팅 했을 시 */}
        {typeOn === BET_TYPE_ON.UNIFIED_LIVE && (<LiveTagIco/>)}
        {/* 믹스 베팅 했을 시 */}
        {isMixBetting && (<MixTagIco/>)}
        {/* 베팅권으로 베팅 했을 시 */}
        {betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G && (
          <BetCouponTag className="betting-history bet-coupon-tag"><BetIco/></BetCouponTag>
        )}
        {/* 추가 배당 표시 */}
        {extraOddsType === EXTRA_ODDS_TYPE.GOD_BLESS_ITEM && AdditionalDividendMark}
        {/* 오즈메이커 취소 */}
        {CancelToolTip}

        {/* ****** 베팅 내역 퀵 메뉴 버튼(점 메뉴) ****** */}
        {currentTabKey !== BETTING_HISTORY_TAB_KEY.SHARED
          && pageType !== PAGE_TYPE.USER_PICK
          && pageType !== PAGE_TYPE.USER_PICK_DETAIL
          && pageType !== PAGE_TYPE.MATCHUP_DETAIL_PICK
          && (
            <Fragment>
              {(isMobile && !showBettingListItemSelectBtn && !deleteBetActive) && (
                <Popover
                  placement="bottomRight"
                  visible={visiblePopover}
                  onVisibleChange={onVisibleChange}
                  content={bettingHistoryQuickMenu}
                  trigger="click"
                  overlayClassName="betting-history-quick-menu"
                  getPopupContainer={setPopoverPopup}
                >
                  {bettingHistoryQuickBtn}
                </Popover>)}

              {(!isMobile && !showBettingListItemSelectBtn && !deleteBetActive) && (
                <Popover
                  placement="bottomRight"
                  visible={visiblePopover}
                  onVisibleChange={onVisibleChange}
                  content={bettingHistoryQuickMenu}
                  trigger="hover"
                  mouseLeaveDelay={0.2}
                  overlayClassName="betting-history-quick-menu"
                >
                  {bettingHistoryQuickBtn}
                </Popover>
              )}
            </Fragment>
          )
        }

        {(currentTabKey === BETTING_HISTORY_TAB_KEY.SHARED
            && firstDateOfMatch.valueOf() > new Date().valueOf() && !deleteBetActive && !showBettingListItemSelectBtn)
          && (<Button secondary className="do-bet-btn" onClick={onClickBettingButton}>베팅</Button>)}

        {/* TODO 추가메뉴의 '삭제' 버튼 클릭 시 해당 버튼으로 교체되어야 합니다. */}
        {/* TODO 여러개 선택 가능해야 합니다. */}
        {(deleteBetActive && !showBettingListItemSelectBtn) &&
          (
            <Checkbox
              key={checkboxKey}
              checked={deleteChecked}
              css={BettingHistoryShareBtnStyle}
              onChange={onChangeDeleteCheckBox}
            >
              선택
            </Checkbox>
          )
        }


        {showBettingListItemSelectBtn && currentTabKey !== BETTING_HISTORY_TAB_KEY.SHARED && (
          <Checkbox
            key={checkboxKey}
            checked={selectionChecked}
            css={BettingHistoryShareBtnStyle}
            onClick={onClickBetHistoryItemSelectHandler}
          >
            선택
          </Checkbox>
        )}
      </div>

      <Collapse defaultActiveKey={fromUserPick() && Number(idx) === 0 ? panelKey : ''}>
        <Panel showArrow={false} header={elemHeader} key={panelKey}>
          {eleCollapsed}
        </Panel>
      </Collapse>
    </BettingHistoryHeader>
  )

  return (
    <Fragment>
      <Slide bottom cascade duration={600}>
        {BettingHistoryList}
      </Slide>
    </Fragment>
  )
}

export default observer(BettingHistoryListItem)
